export default "__VITE_ASSET__6ZaW9JK9__"